import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { useExternalSupport } from "utils";

import { Container } from "components/common";
import General from "components/Pages/Settings/common/Sections/General";
import { colors } from "theme";
import { isSupport as checkSupport } from "routes/pageConfig";
import { NAV_BAR_ITEMS, NUM_MOBILE_NAV_ITEMS } from "components/Navbar/consts";
import { hasPagePermission } from "routes/utils";

const MORE_QUERY = gql`
  query More {
    user {
      first_name
      last_name
      credit {
        credit_limit
      }
    }
  }
`;

const iconSize = 31;

const More = () => {
  const { push } = useHistory();
  const { loading, error, data } = useQuery(MORE_QUERY);
  const { openExternalSupport } = useExternalSupport();
  const moreOptions = [];
  let mainOptionsCount = 0;
  NAV_BAR_ITEMS.forEach((item) => {
    const hasPerms = hasPagePermission(item);
    if (!hasPerms || item.navBarSettings?.mobileNav?.hide) {
      return;
    }
    if (mainOptionsCount < NUM_MOBILE_NAV_ITEMS) {
      mainOptionsCount++;
    } else if (item.key !== "more") {
      moreOptions.push(item);
    }
  });

  if (loading) {
    return "Loading...";
  }
  if (error) {
    return `Error! ${error.message}`;
  }
  const { user } = data;
  return (
    <>
      <General className="mb-2" user={user} />
      <h1 className="mb-2">More</h1>
      <div className="flex flex-wrap -mx-2">
        {moreOptions.map((item) => {
          const { key, Icon, iconName, path, navBarSettings, title } = item;
          return (
            <button
              key={key}
              type="button"
              className="w-1/3 px-2 mb-2"
              onClick={() => {
                const isSupport = checkSupport(item);
                if (isSupport) {
                  openExternalSupport();
                } else {
                  push(path);
                }
              }}
            >
              <Container paddingVertical={16}>
                {Icon && (
                  <Icon
                    color={colors["black-secondary"]}
                    className="mb-2 self-center"
                    style={{ height: iconSize, width: iconSize }}
                  />
                )}
                {iconName && (
                  <i
                    style={{ width: iconSize, fontSize: iconSize }}
                    className={`mb-2 self-center fas ${iconName} text-center`}
                  />
                )}
                <div className="text-center capitalize text-xs">
                  {navBarSettings?.mobileNav?.title || title || key}
                </div>
              </Container>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default compose(
  connect((state) => ({
    userId: state.user.id,
  })),
)(More);
